import { withCompController } from '@wix/editor-elements-integrations'
import { FluidColumnsRepeaterCompProps, FluidColumnsRepeaterStateRefValues } from './types'

export const FluidColumnsRepeaterController = withCompController<
	FluidColumnsRepeaterCompProps,
	FluidColumnsRepeaterCompProps,
	FluidColumnsRepeaterCompProps,
	FluidColumnsRepeaterStateRefValues
>(({ mapperProps, stateValues }) => {
	return {
		...mapperProps,
		observeChildListChange: stateValues.observeChildListChange,
	}
})
